import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Card as AntdCard } from 'antd'
import { Radio } from 'components/patterns'
import { Part__Image_unavailable } from 'components/SwitchAndGauge/parts-components'

export const TitleWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`

export const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
  color: ${themeColor('blackPrimary')};
`

export const ContentWrapper = styled.span`
  font-size: 14px;
  margin-left: 10px;
  color: ${themeColor('blackPrimary')};
`

// PBI 147363 - Documentation 4: Card padding per Figma (25px top/right/bottom, 16px left)
export const StyledAntdCard = styled(AntdCard)`
  &&.ant-card.ant-card-bordered {
    display: flex;
    width: 100%;
    height: 165px;
    padding: 25px 9px 25px 9px;
    align-items: center;
    gap: 16px;
    border-radius: 3px;
    border: 1px solid ${themeColor('greyPrimary')};
    background: #fff;
    cursor: pointer;
    box-sizing: border-box;

    &:hover {
      border-color: ${themeColor('blueSecondary')};
      background: #fff;
    }

    .ant-card-body {
      display: flex;
      align-items: center;
      gap: 16px;
      padding: 0;
      width: 100%;
    }
  }

  &.selected {
    &&.ant-card.ant-card-bordered {
      border: 1px solid ${themeColor('blueSecondary')};
    }
  }
`

export const StyledRadio = styled(Radio)`
  &&& {
    margin: 0;
    padding: 0;
    flex-shrink: 0;
  }
`

// export const StyledRadio = styled(Radio)`
//   /* PBI 147363 - Documentation 4: Hide radio, whole card is clickable */
//   &&& {
//     position: absolute;
//     top: 8px;
//     right: 8px;
//   }
// `

// PBI 147363 - Documentation 4: Horizontal card layout per Figma
export const CardContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin: 0;
  padding: 0;
`

export const CardTextSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  word-break: keep-all;
`

export const PartImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 100px;
  flex-shrink: 0;
`

// PBI 147363 - Documentation 4: Title text styles per Figma
export const PartNumber = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: #07070f;
  white-space: nowrap;
`

export const DetailRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  font-size: 13px;
  line-height: 18px;
`

// PBI 147363 - Documentation 4: Label text styles per Figma (Description:, Type:)
export const DetailLabel = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: rgba(7, 7, 15, 0.7);
  flex-shrink: 0;
  white-space: nowrap;
`

// PBI 147363 - Documentation 4: Value text styles per Figma
export const DetailValue = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  color: rgba(7, 7, 15, 0.7);
`

export const BlankPartGraphics = styled(Part__Image_unavailable)`
  position: absolute;
  z-index: 2;
  top: 32px;
  left: 16px;
`
